/**
 * 커스텀 다이얼로그 composable
 * alert(), confirm() 대체용
 * iOS WebView에서도 동작하는 HTML 기반 모달
 */
import { ref } from 'vue'

export interface DialogOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
}

export interface DialogState {
  isOpen: boolean
  type: 'alert' | 'confirm'
  title: string
  message: string
  confirmText: string
  cancelText: string
  resolve: ((value: boolean) => void) | null
}

// 전역 상태 (싱글톤 패턴)
const dialogState = ref<DialogState>({
  isOpen: false,
  type: 'alert',
  title: '',
  message: '',
  confirmText: '확인',
  cancelText: '취소',
  resolve: null,
})

export const useDialog = () => {
  /**
   * alert 대체 함수
   * @param message 표시할 메시지
   * @param title 다이얼로그 제목 (선택)
   */
  const showAlert = (message: string, title?: string): Promise<void> => {
    console.log('🔔 [useDialog] showAlert 호출:', message)
    return new Promise((resolve) => {
      dialogState.value = {
        isOpen: true,
        type: 'alert',
        title: title || '',
        message,
        confirmText: '확인',
        cancelText: '취소',
        resolve: () => {
          console.log('✅ [useDialog] showAlert resolve')
          resolve()
        },
      }
      console.log('📊 [useDialog] dialogState 업데이트:', dialogState.value)
    })
  }

  /**
   * confirm 대체 함수
   * @param message 표시할 메시지
   * @param options 옵션 (제목, 버튼 텍스트 등)
   */
  const showConfirm = (message: string, options?: Partial<DialogOptions>): Promise<boolean> => {
    return new Promise((resolve) => {
      dialogState.value = {
        isOpen: true,
        type: 'confirm',
        title: options?.title || '',
        message,
        confirmText: options?.confirmText || '확인',
        cancelText: options?.cancelText || '취소',
        resolve,
      }
    })
  }

  /**
   * 다이얼로그 닫기 (내부용)
   */
  const closeDialog = (result: boolean) => {
    if (dialogState.value.resolve) {
      dialogState.value.resolve(result)
    }
    dialogState.value.isOpen = false
    dialogState.value.resolve = null
  }

  return {
    dialogState,
    showAlert,
    showConfirm,
    closeDialog,
  }
}
